import React, { useEffect, useState } from 'react';
import split from 'lodash/split';
import BoxContainer from '../../BoxContainer/BoxContainer';
import css from '../../../styles/modules/PaymentSummary/paymentsummary.module.css';
import {
  PaymintsButton,
  BUTTON_TYPE,
} from 'paymints-address-autocomplete-field';
import get from 'lodash/get';
import {
  useAllBrandingsFromTenant,
  useAllTenants,
} from '../../../utils/service/service_tenant_api';
import FAQMain from '../Components/FAQMain';
import InfoCard from '../Components/InfoCard';
import { useClientByPhone } from '../../../utils/service/service_user_api';
import { useAllTransfersSorted } from '../../../hooks/useAllTransfersSorted';
import { getClientStore } from '../../../utils/util';
import useDeepCompareEffect from 'use-deep-compare-effect';
import useAllCreditTransferTypes from '../../../hooks/useAllCreditTransferTypes';
import useAllPurposeConfigsFromTenant from '../../../hooks/useAllPurposeConfigsFromTenant';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import PaymentDetails from './PaymentDetails';
// import useAllTransferArchives from '../../../hooks/useAllTransferArchives';
import useTransferArchiveByClientId from '../../../hooks/useTransferArchiveByClientId';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../../reducers/utility/utilityActions';
import SpinnerLoader from '../../SpinnerLoader/SpinnerLoader';
import displayPageHeader from '../../../utils/displayPageHeadline';
import { AiFillPlusCircle } from 'react-icons/ai';
import useWindowWidth from '../../../hooks/nonGQLhooks/useWindowWidth';
import { closeNavbar } from '../../../reducers/navbar/navbarActions';
import FloatingContainer from '../../FloatingContainer/FloatingContainer';

function RenderView({
  archivesLoading,
  transferArchives,
  isCompiling,
  pathname,
  transfers,
  branding,
  tenant,
}) {
  const [archivesOpen, setArchivesOpen] = useState(false);
  if (pathname.includes('/transfer-history')) {
    return (
      <div className={css.dataWrapper}>
        {isCompiling ? <SpinnerLoader /> : null}
        <div className={css.infoCardWrapper}>
          {transfers?.map(
            (
              {
                sourceBankAccount,
                destBankAccount,
                _id,
                attachments,
                method,
                propertyCity,
                propertyState,
                propertyZipcode,
                propertyAddress2,
                propertyAddress1,
                purpose,
                amount,
                fee,
                disbursement,
                status,
                type,
                transferType,
                client,
                createdAt_utc,
                updatedAt_utc,
              },
              index,
            ) => {
              return (
                <InfoCard
                  transferType={transferType}
                  attachments={attachments}
                  sourceBankAccount={sourceBankAccount}
                  destBankAccount={destBankAccount}
                  tenantId={tenant?._id}
                  transferId={_id}
                  method={method}
                  propertyCity={propertyCity}
                  propertyState={propertyState}
                  propertyZipcode={propertyZipcode}
                  propertyAddress2={propertyAddress2}
                  propertyAddress1={propertyAddress1}
                  purpose={purpose}
                  amount={amount}
                  fee={fee}
                  disbursement={disbursement}
                  createdAt={createdAt_utc}
                  updatedAt={updatedAt_utc}
                  key={client?.firstName + index}
                  status={status}
                  type={transferType?.name}
                  client={client}
                  tenant={tenant}
                  tenantLogo={branding?.logoURL}
                />
              );
            },
          )}

          {archivesOpen
            ? !archivesLoading
              ? transferArchives?.map(
                  (
                    {
                      transferType,
                      sourceBankAccount,
                      destBankAccount,
                      _id,
                      attachment,
                      method,
                      propertyCity,
                      propertyState,
                      propertyZipcode,
                      propertyAddress2,
                      propertyAddress1,
                      purpose,
                      amount,
                      fee,
                      disbursement,
                      status,
                      client,
                      createdAt_utc,
                      updatedAt_utc,
                    },
                    index,
                  ) => {
                    return (
                      <InfoCard
                        transferType={transferType}
                        attachment={attachment}
                        sourceBankAccount={sourceBankAccount}
                        destBankAccount={destBankAccount}
                        tenantId={tenant?._id}
                        transferId={_id}
                        method={method}
                        propertyCity={propertyCity}
                        propertyState={propertyState}
                        propertyZipcode={propertyZipcode}
                        propertyAddress2={propertyAddress2}
                        propertyAddress1={propertyAddress1}
                        purpose={purpose}
                        amount={amount}
                        fee={fee}
                        disbursement={disbursement}
                        createdAt={createdAt_utc}
                        updatedAt={updatedAt_utc}
                        key={client?.firstName + index}
                        status={status}
                        type={transferType?.name}
                        client={client}
                        tenant={tenant}
                        tenantLogo={branding?.logoURL}
                      />
                    );
                  },
                )
              : null
            : null}
        </div>
        {/* {!isCompiling ? (
          <button
            onClick={() => setArchivesOpen(!archivesOpen)}
            className={css.loadMoreBtn}
          >
            {!archivesOpen
              ? 'Open Archives'
              : !archivesLoading
              ? 'Close Archives'
              : 'Please Wait...'}
          </button>
        ) : null} */}
      </div>
    );
  } else if (pathname.includes('/payment-details')) {
    return (
      <div className={css.dataWrapper}>
        <PaymentDetails tenant={tenant} tenantLogo={branding?.logoURL} />
      </div>
    );
  }
}

export default function PaymentSummary({ tenant }) {
  //legacy hack for missing navBar - used across the app. SHOULD BE FIXED!
  const nav = document.querySelector('.menu-nav-bar__grey-bar');
  if (!nav) window.location.reload();

  const dispatch = useDispatch();
  const history = useHistory();
  const { pathname } = history?.location;

  const { branding } = useAllBrandingsFromTenant(tenant?._id, true);

  const purposeConfig = useAllPurposeConfigsFromTenant(tenant?._id);

  const [loading, setLocalLoading] = useState(true);
  const [isCompiling, setIsCompling] = useState(true);

  const [transfers, setTransfers] = useState([]);
  // get client information
  const { user } = getClientStore();

  const { loadingArchive, transferArchives } = useTransferArchiveByClientId(
    user?._id,
    tenant?._id,
  );

  const { loadingSearch, client } = useClientByPhone(user?.mobilePhone || null);
  const clientID = get(client, '_id');

  // retrieves newest transfer information
  const {
    loadingSearchTransfer,
    transfers: transfersNew,
    refetchTransfers,
  } = useAllTransfersSorted(client?._id, tenant?._id);

  const width = useWindowWidth();
  useEffect(() => {
    if (width < 768) {
      dispatch(closeNavbar());
    }
  }, []);

  useEffect(() => {
    if (!purposeConfig?.loading && !loadingSearchTransfer && !loadingSearch) {
      setLocalLoading(false);
    }
  }, [purposeConfig, loadingSearchTransfer, loadingSearch]);

  // sets transfers to the newest transfers received
  useEffect(() => {
    if (!loading && transfersNew) {
      let purposeObj = {};
      const config = JSON.parse(purposeConfig?.purposeConfigs[0]?.config);

      //offloading the data of the purpose config into Object for faster access
      //this avoids double looping

      for (let i = 0; i < config?.length; i++) {
        purposeObj[config[i]?.purpose] = {
          ...config[i],
        };
      }

      let mutated = transfersNew?.map((transfer) => {
        return {
          ...transfer,
          method: purposeObj[transfer?.purpose]?.method,
        };
      });

      //removes drafts from array
      mutated = mutated?.filter(
        (item) => item?.status.toLowerCase() !== 'draft',
      );

      setTransfers(mutated);
      setIsCompling(false);
    }
  }, [loading, transfersNew]);

  return (
    <div className={css.wrapper}>
      <BoxContainer withDoubleBorder withTopLogo widest>
        <div className="d-flex justify-content-start align-items-center">
          <div className="create-account__title">
            {displayPageHeader(history?.location?.pathname)}
          </div>
          {history?.location?.pathname?.includes('/transfer-history') ? (
            <AiFillPlusCircle
              className="ml-2"
              size={40}
              style={{ color: '#4162fa', cursor: 'pointer' }}
              onClick={() => history.push('/create-account/step-3')}
            />
          ) : null}
        </div>
        <RenderView
          archivesLoading={loadingArchive}
          transferArchives={transferArchives}
          isCompiling={isCompiling}
          pathname={pathname}
          transfers={transfers}
          branding={branding}
          tenant={tenant}
        />
        {/* <FAQMain /> */}
      </BoxContainer>
    </div>
  );
}
